import { render } from "./Palette.vue?vue&type=template&id=55e3242f"
import script from "./Palette.vue?vue&type=script&lang=js"
export * from "./Palette.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Palette.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55e3242f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55e3242f', __exports__)) {
    api.reload('55e3242f', __exports__)
  }
  
  module.hot.accept("./Palette.vue?vue&type=template&id=55e3242f", () => {
    api.rerender('55e3242f', render)
  })

}


export default __exports__